import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faNewspaper, faClock, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import indIcon from "../../assets/Ind.png";
import bikeImage from "../../assets/bike.png";
import styles from "./HighSecurityPlate.module.css";
import HighSecurityPlateForm from "./HighSecurityPlateForm";

// Mock news data - all related to High Security Registration Plate (HSRP)
const newsData = [
  {
    id: 1,
    title: "Mandatory HSRP Compliance",
    subtitle: "All vaahans must install HSRP by December 2025",
    category: "Policy Updates",
    time: "2 hours ago",
    image: "🚨",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    priority: "high"
  },
  {
    id: 2,
    title: "Online HSRP Booking Launched",
    subtitle: "Book your HSRP appointment online in just 5 minutes",
    category: "Digital Services",
    time: "4 hours ago",
    image: "📱",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    priority: "high"
  },
  {
    id: 3,
    title: "HSRP Installation Centers Expanded",
    subtitle: "New centers opened in 50 cities for faster HSRP fitting",
    category: "Infrastructure",
    time: "1 day ago",
    image: "🏬",
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    priority: "medium"
  },
  {
    id: 4,
    title: "Subsidized HSRP Fees",
    subtitle: "Government offers 30% subsidy on HSRP for two-wheelers",
    category: "Fee Updates",
    time: "2 days ago",
    image: "💸",
    gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    priority: "medium"
  },
  {
    id: 5,
    title: "Home Delivery of HSRP",
    subtitle: "Get your HSRP delivered and installed at your doorstep",
    category: "Delivery Services",
    time: "3 days ago",
    image: "🚚",
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    priority: "medium"
  },
  {
    id: 6,
    title: "HSRP Verification App",
    subtitle: "New app launched to verify HSRP authenticity online",
    category: "Digital Services",
    time: "4 days ago",
    image: "🔍",
    gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    priority: "low"
  },
  {
    id: 7,
    title: "Extended HSRP Deadlines",
    subtitle: "Compliance deadline extended for old vaahans till 2026",
    category: "Policy Updates",
    time: "5 days ago",
    image: "⏳",
    gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
    priority: "medium"
  },
  {
    id: 8,
    title: "Anti-Theft HSRP Features",
    subtitle: "New HSRP design includes advanced anti-theft technology",
    category: "Technology Updates",
    time: "1 week ago",
    image: "🔒",
    gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
    priority: "low"
  }
];

function NewsWidget() {
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // Change news daily based on date
  useEffect(() => {
    const today = new Date();
    const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
    setCurrentNewsIndex(dayOfYear % newsData.length);
  }, []);

  // Auto-rotate news every 10 seconds for demo (remove in production)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentNewsIndex((prev) => (prev + 1) % newsData.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const currentNews = newsData[currentNewsIndex];

  const handleNewsClick = () => {
    console.log("News clicked:", currentNews);
  };

  return (
    <div className={styles.newsWidget} onClick={handleNewsClick}>
      <div
        className={styles.newsCard}
        style={{ background: currentNews.gradient }}
      >
        <div className={styles.newsHeader}>
          <div className={styles.newsIcon}>
            <FontAwesomeIcon icon={faNewspaper} />
          </div>
          <div className={styles.newsTime}>
            <FontAwesomeIcon icon={faClock} />
            <span>{currentNews.time}</span>
          </div>
        </div>

        <div className={styles.newsContent}>
          <div className={styles.newsEmoji}>{currentNews.image}</div>
          <div className={styles.newsText}>
            <div className={styles.newsCategory}>{currentNews.category}</div>
            <h3 className={styles.newsTitle}>{currentNews.title}</h3>
            <p className={styles.newsSubtitle}>{currentNews.subtitle}</p>
          </div>
        </div>

        <div className={styles.newsFooter}>
          <div className={styles.priorityIndicator}>
            <div className={`${styles.priorityDot} ${styles[currentNews.priority]}`}></div>
            <span className={styles.priorityText}>
              {currentNews.priority.charAt(0).toUpperCase() + currentNews.priority.slice(1)} Priority
            </span>
          </div>
          <FontAwesomeIcon icon={faArrowRight} className={styles.arrowIcon} />
        </div>
      </div>

      <div className={styles.newsIndicators}>
        {newsData.map((_, index) => (
          <div
            key={index}
            className={`${styles.indicator} ${index === currentNewsIndex ? styles.active : ''}`}
          />
        ))}
      </div>
    </div>
  );
}

function HighSecurityPlate() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <NewsWidget />
          {/* <div className={styles.status}>*E*T**I*G*</div>
          <div className={styles.company}>TVS MOTOS COMPANY LTD, TVS</div>
          <div className={styles.model}>XL100 HEAVY DUTY</div>
          <div className={styles.searchField}>
            <div className={styles.prefix}>
              <img src={indIcon} alt="IND" />
              <span>IND</span>
            </div>
            <input
              type="text"
              defaultValue="MH 15 CV 2211"
              className={styles.input}
            />
            <button className={styles.searchBtn}>
              <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
            </button>
          </div>
          <div className={styles.buttonGroup}>
            <button className={styles.actionBtn}>View RC Details</button>
            <button className={styles.actionBtn}>Add To Garage</button>
          </div> */}
        </div>
        <div>
          <img src={bikeImage} alt="Vaahan" className={styles.vehicleImage} />
        </div>
      </div>
      <HighSecurityPlateForm />
    </div>
  );
}

export default HighSecurityPlate;